import request from '@/utils/request';

export default {
    getItems: async({ dispatch, commit }, optionClassId) => {
        await request({
            method: 'get',
            url: '/admin/resales',
            params: {
                optionClassId
            }})
            .then(res => {
                if (res.data) {
                    commit('SET_RESALES', res.data);
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
    },

    save: async({ commit, dispatch }, data) => {
        if (!data.id) {
            return await request({ method: 'post', url: `/admin/resales`, data })
            .then(res => {
                if (res.data) {
                    commit('CREATE_RESALE', res.data);

                    dispatch('alert/addMessage', {
                        type: 'success',
                        message: 'success'
                    }, { root: true });
                }
            }).catch(error => {
                if(error.response && error.response.data && error.response.data.error) {
                    dispatch('alert/addMessage', {
                        message: error.response.data.error
                    }, { root: true });
                }
            });
        }

        await request({
            method: 'put',
            url: `/admin/resales/${data.dealerId}/${data.buyerId}`,
            data
        }).then(res => {
            if (res.data) {
                commit('UPDATE_RESALE', res.data);

                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }
        }).catch(error => {
            if(error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    },

    remove: async({ commit, dispatch }, { id, dealerId, buyerId, optionClassId }) => {
        await request({
            method: 'delete',
            url: `/admin/resales/${dealerId}/${buyerId}/${optionClassId}`
        }).then(res => {
            if (res.status === 204) {
                commit('REMOVE_RESALE', id);

                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });
            }
        }).catch(error => {
            if(error.response && error.response.data && error.response.data.error) {
                dispatch('alert/addMessage', {
                    message: error.response.data.error
                }, { root: true });
            }
        });
    }
};
